import React from "react"

import "./RatingCard.scss"

const RatingCard = (props) => {
  return (
    <section className="rating-card">
      <div className="rating-card__container">
        <div className="rating-card__container__card">
          {" "}
          <div className="rating-card__container__card__rating">
            <div className="star">
              <span className="star__one">&#9733;</span>
            </div>
            <div className="star">
              <span className="star__two">&#9733;</span>
            </div>
            <div className="star">
              <span className="star__three">&#9733;</span>
            </div>
            <div className="star">
              <span className="star__two">&#9733;</span>
            </div>
            <div className="star">
              <span className="star__one">&#9733;</span>
            </div>
          </div>
          <div className="rating-card__container__card__text" dangerouslySetInnerHTML={{ __html: props.rating }} />
          <div className="rating-card__container__card__sub-text">
            { props.name }
          </div>
        </div>
      </div>
    </section>
  )
}

export default RatingCard
